<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">科目汇总</span>
    </div>
    <div class="margin-right-left margin-top">
      <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
        <div v-if="params.start!==params.end">{{ fqFormat(params.start) }} 至 {{ fqFormat(params.end) }}</div>
        <div v-else>{{ fqFormat(params.start) }}</div>
        <template #content>
          <Form style="padding: 10px;width: 400px">
            <FormItem class="!pb-5px" label="会计期间">
              <div class="flex items-center">
                <Select @change="dateCheck" v-model="params.start" :deletable="false" filterable :datas="checkoutSelect"/>
                <span class="mx-8px">至</span>
                <Select @change="dateCheck" v-model="params.end" :deletable="false" filterable :datas="checkoutSelect"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px" label="起始科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName"
                      v-model="params.subjectStart">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="结束科目">
              <Select :datas="subjectList" :filter="sfilter" keyName="code" titleName="fullName"
                      v-model="params.subjectEnd">
                <template #show="{value}">
                  {{ value.code }} {{ value.fullName }}
                </template>
                <template #item="{item}">
                  {{ item.code }} {{ item.fullName }}
                </template>
              </Select>
            </FormItem>
            <FormItem class="!pb-5px" label="科目级别">
              <div class="flex items-center">
                <Select v-model="params.levelStart" :deletable="false" filterable :datas="[1,2,3,4]"/>
                <span class="mx-8px">至</span>
                <Select v-model="params.levelEnd" :deletable="false" filterable :datas="[1,2,3,4]"/>
              </div>
            </FormItem>
            <FormItem class="!pb-5px">
              <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
              <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
              <Button @click="resetForm">重置</Button>
            </FormItem>
          </Form>
        </template>
      </DropdownCustom>
      <div class="float-right flex items-center">
        <Checkbox class="mr-16px" v-model="showNumPrice">显示数量金额</Checkbox>
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="h-panel-body" type="flex">
	    <vxe-table show-footer :footer-method="footerMethod" ref="xTable" :data="dataList" v-if="!showNumPrice" 
      :tree-config="{transform: false, expandAll:true,showIcon:false,rowField: 'treeId', parentField: 'parentTreeId'}" 
      border>
		    <vxe-column title="科目编码" field="subjectCode" tree-node/>
		    <vxe-column title="科目名称" field="subjectName"/>
		    <vxe-colgroup title="金额合计" align="center">
			    <vxe-column title="借方" field="debit" align="right" formatter="toMoney"/>
			    <vxe-column title="贷方" field="credit" align="right" formatter="toMoney"/>
		    </vxe-colgroup>
	    </vxe-table>
	    <vxe-table show-footer :footer-method="footerMethod" ref="xTable" :data="dataList" v-else :tree-config="{transform: false, expandAll:true,showIcon:false,rowField: 'treeId', parentField: 'parentTreeId'}" border>
		    <vxe-column title="科目编码" field="subjectCode" tree-node/>
		    <vxe-column title="科目名称" field="subjectName"/>
		    <vxe-column title="单位" field="unit"/>
		    <vxe-colgroup title="金额合计" align="center">
			    <vxe-column title="借方" field="debit" align="right" formatter="toMoney"/>
			    <vxe-column title="贷方" field="credit" align="right" formatter="toMoney"/>
		    </vxe-colgroup>
		    <vxe-colgroup title="数量合计" align="center">
			    <vxe-column title="借方" field="debitQuantity" align="right" formatter="toMoney"/>
			    <vxe-column title="贷方" field="creditQuantity" align="right" formatter="toMoney"/>
		    </vxe-colgroup>
	    </vxe-table>
    </div>
  </app-content>
</template>

<script>

import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import {clone} from "xe-utils";
import setting from "@/api/setting";

export default {
  name: "SubjectSummary",
  data() {
    return {
      subjectList: [],
      dataList: [],
      showNumPrice: false,
      loading: false,
      params: {
	      start: null,
	      end: null,
	      currencyId: null,
	      levelStart: 1,
	      levelEnd: 4,
	      subjectStart: null,
	      subjectEnd: null,
      },
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
          .vxe-table tfoot td {
            font-size: 12px;
            border: 1px solid #000;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>科目汇总表</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>编制单位：${this.currentAccountSets.companyName}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          return `${headerHtml}${content}`;
        },
      },
    }
  },
  computed: {
	  ...mapState(['currentAccountSets']),
	  ...mapGetters(['checkoutSelect', 'localCurrency']),
    title() {
			if (!this.params.start) {
				return '';
			}
			if (this.params.start === this.params.end) {
				return manba(this.params.start).format("YYYY年MM期")
			}
			return manba(this.params.start).format("YYYY年MM期") + " - " + manba(this.params.end).format("YYYY年MM期");
		}
  },
  watch: {
    showNumPrice() {
      this.loadList();
    }
  },
  methods: {
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.start);
      let endDate = new Date(this.params.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    footerMethod({ columns, data }) {
      //jxd过滤数组中的二级科目，算合计数，只取一级
      let allData = data;
      let finData = allData.filter(item => item.subjectCode.length == 4);
      const row = [];
      columns.forEach(col => {
        if ('debit' === col.property) {
          const debitTotal = finData.reduce((total, item) => total + parseFloat(item.debit), 0);
          row.push(debitTotal.toFixed(2))
        } else if('credit' === col.property){
          const creditTotal = finData.reduce((total, item) => total + parseFloat(item.credit), 0);
          row.push(creditTotal.toFixed(2))
        } else if('debitQuantity' === col.property){
          const debitQuantityTotal = finData.reduce((total, item) => total + parseFloat(item.debitQuantity), 0);
          row.push(debitQuantityTotal.toFixed(4))
        } else if('creditQuantity' === col.property){
          const creditQuantityTotal = finData.reduce((total, item) => total + parseFloat(item.creditQuantity), 0);
          row.push(creditQuantityTotal.toFixed(4))
        } else {
          row.push(col.property === "subjectName" ? '合计' : "")
        }
      })
      return [row]
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    },
    sfilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    loadList() {
      this.loading = true;
      accountbook.loadSubjectSummary(Object.assign({}, this.params, {
        showNumPrice: this.showNumPrice
      })).then(({data}) => {
	      this.dataList = data;
	      this.$nextTick(() => {
		      this.$refs.xTable.setAllTreeExpand(true);
	      });
        this.$refs.paramsDropdown.hide()
      }).finally(() => {
        this.loading = false;
      })
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${manba(this.accountDate).format("YYYY年MM期")}-科目汇总.xls`, data)
      })
    },
    printData() {
      const xTable = this.$refs.xTable;
      xTable.print({
        ...this.tablePrint,
      });
    },
  },
  created() {
    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
	  this.params.end = this.params.start;
	  this.params.currencyId = this.localCurrency.id;
	  this.cloneParams = clone(this.params, true);
    // setting.subject.voucherSelect().then(({data}) => {
    //   this.subjectList = data;
    // })
    //jxd这里的科目选择应该是所有科目
    setting.subject.listAll().then(({data}) => {
      this.subjectList = data;
    })
    this.loadList();
  }
}
</script>
